import api from "./api";

interface IInvoiceProps { 
    id: number;
    closed_at: Date;
    accumulated: number;
    is_closed: boolean;
    transfer_estimate: number;
    total_money: number;
    requests: number;
    materials: any[];
}

export const overview = async (date: string) => {
    const { data } = await api.get<IInvoiceProps>(`/billing/partner/info/?date=${date}`);

    return data
}



